import { Component, ChangeDetectorRef } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ActionSheetController,
  AlertController
} from 'ionic-angular';
import { TaskQL, Task } from '../../providers/tasks/models';
import { TasksProvider } from '../../providers/tasks/tasks';
import { DevicesProvider } from '../../providers/devices/devices';
import { ProvidersProvider } from '../../providers/providers/providers';
import { AuthProvider } from '../../providers/auth/auth';
import { Provider } from '../../providers/providers/models';
import { TasksCompleteDetailPage } from '../tasks-complete-detail/tasks-complete-detail';
import { UtilsProvider } from '../../providers/utils/utils';

/**
 * Generated class for the TasksCompletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-tasks-complete',
  templateUrl: 'tasks-complete.html'
})

export class TasksCompletePage {
  public tasks: TaskQL[];
  private isloading: boolean = false;
  private selectedStatus: Array<string> = [Task.StatusEnum.Closed];
  private selectedType: string = '';
  private providers: Provider[];
  private updateTask: any;
  private startDate: Date;
  private startDateStr: string;
  private endDate: Date;
  private endDateStr: string;
  private pageObject = {
    page: 1,
    lookAfter: null,
    pageSize: 10
  };
  private lastRequestInfo: {
    totalCount: number;
    nextLookAfterKey: number | string;
    previousLookBeforeKey: number | string;
    items: any[];
    isdone: boolean;
  } = null;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public actionSheetCtrl: ActionSheetController,
    public alertCtrl: AlertController,
    private cd: ChangeDetectorRef,
    private tasksProvider: TasksProvider,
    private authProvider: AuthProvider,
    private devicesProvider: DevicesProvider,
    private providersProvider: ProvidersProvider,
    private utilsProvider: UtilsProvider
  ) {
    this.isloading = false;
    this.updateTask = this.navParams.get('updateTask');
    this.navParams.data.updateTask = null;
  }
  
  ionViewDidLoad() {}
  ionViewDidEnter() {
    this.endDate = new Date();
    this.endDate.setHours(23);
    this.endDate.setMinutes(59);
    this.endDate.setSeconds(59);
    this.endDateStr = this.endDate.toISOString();

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 30);
    this.startDate.setHours(0);
    this.startDate.setMinutes(0);
    this.startDate.setSeconds(0);
    this.startDateStr = this.startDate.toISOString();

    this.lastRequestInfo = null;
    this.providersProvider.getProviders().subscribe(providersResult => {
      this.providers = providersResult;
      this.initTasks(true);
    });
  }

  initTasks(refresh: boolean = false, event?) {
    // updateTask
    if (!this.isloading) {
      this.isloading = true;
      if (refresh && !event) {
        this.lastRequestInfo = null;
      }
      var startDate = this.startDate.getTime() - 86399999;
      var endDate = this.endDate.getTime();
      const params = {
        limit: 20,
        filters: {
          status: { _in: ['closed'] },
          completedDate: {
            _gt: startDate,
            _lt: endDate
          }
        },
        sortFilter: {
          field: 'assignedDate',
          direction: 'ASC'
        },
        lookAfter: null
      };

      if (this.lastRequestInfo) {
        params.lookAfter = this.lastRequestInfo.nextLookAfterKey;
      }

      var isScheduler =  this.authProvider.userData.isSchedular; // check if scheduler to show other users data
      this.tasksProvider.getTasks(params, !isScheduler).subscribe(
        data => {
          var pretasks =
            this.tasks && this.tasks.length > 0
              ? this.tasks.concat(data.items)
              : data.items;
              // check if tasks are from one of my companies
          if (isScheduler) {
            this.authProvider.getUser().subscribe(
              userResult => {
                var filterCompanies = userResult.companies.filter(company => !company.includes('plumber-connect'))
                this.tasks = pretasks.filter(task => {
                  return filterCompanies.includes(task.companyId) || task.userId == userResult.uid;
                });
                this._updateView(data, event);
              },
              error => {
                console.log('error',error)
              }
            );
          } else {
            this.tasks = pretasks;
            this._updateView(data, event); 
          }
        },
        e => {
          this.cd.detectChanges();
          if (event) event.complete();
          this.isloading = false;
        }
      );
    }
  }

        _updateView(data:any, event?: any) {
          if (!this.lastRequestInfo) {
            this.lastRequestInfo = data;
          } else {
            this.lastRequestInfo.nextLookAfterKey = data.nextLookAfterKey;
            this.lastRequestInfo.previousLookBeforeKey = data.previousLookBeforeKey;
            this.lastRequestInfo.items = data.items;
          }

          if (data.totalCount === 0) {
            this.lastRequestInfo.isdone = true;
          }

          this.cd.detectChanges();
          if (event) event.complete();
          this.isloading = false;
        }


  dateChange(datestr: any, type: string) {
    if (!this.isloading) {
      if (type === 'start') {
        this.startDate = new Date(datestr);
      } else {
        this.endDate = new Date(datestr);
      }
      this.tasks = [];
      this.initTasks(true);
    } else {
      this.startDateStr = this.startDate.toISOString();
      this.endDateStr = this.endDate.toISOString();
    }
  }

  dateToString(date: Date) {
    var year = date.getFullYear().toString();
    var month = (date.getMonth() + 1).toString();
    var day = date.getDate().toString();

    return year + '-' + month + '-' + day;
  }

  doInfinite(event) {
    if (!this.isloading && (this.lastRequestInfo && !this.lastRequestInfo.isdone)) {
      this.initTasks(false, event);
    } else {
      event.complete();
    }
  }

  pagingIsComplete() {
    if (this.lastRequestInfo) {
      return this.lastRequestInfo && this.lastRequestInfo.isdone ? true : false;
    }
  }

  doRefresh(event:any) {
    if (!this.isloading) {
      this.tasks = [];
      this.initTasks(true);
    } else {
      event.complete();
    }
  }

  getDeviceType(task: TaskQL) {
    return this.devicesProvider.getDeviceTypeLabel(task.deviceType);
  }

  openTask(task) {
    // Do this to avoid future readonly task error
    const cacheTask = JSON.parse(JSON.stringify(task));
    this.tasksProvider.setSelectedTask(cacheTask);
    this.navCtrl.push(TasksCompleteDetailPage, { task: cacheTask });
  }
}



// WEBPACK FOOTER //
// ./src/pages/tasks-complete/tasks-complete.ts